export const StudentNavItems = [
    {
        title: "dashboard",
        url: "/student/dashboard",
        cName: "navLink",
    },
    {
        title: "syllabus",
        url: "/student/syllabus",
        cName: "navLink"
    },
    {
        title: "liveclass",
        url: "/student/liveclass",
        cName: "navLink",
    },
    // {
    //     title: "Questions",
    //     url: "/student/questions",
    //     cName: "navLink",
    // },
    // {
    //     title: "Analytics",
    //     url: "/student/analytics",
    //     cName: "navLink"
    // },
    {
        title: "tests",
        url: "/student/tests",
        cName: "navLink",
    },
    {
        title: "profile",
        url: "/student/profile",
        cName: "navLink",
    },

]